<template>
  <div class="login_main_container">
    <div class="bg_box">
      <div class="login_box">
        <div class="login_title">
          <img class="logo" src="../../assets/img/jll_logo_rgb.svg" />
          <div class="line"></div>
          <div class="title gray size-30">
            {{ titleLabel }}
          </div>
        </div>
        <div class="login_tab"></div>
        <div class="login_form">
          <forget-form
            :user="user"
            :isSending="isSending"
            :btntxt="btntxt"
            :isValidated="isValidated"
            @sendvercode="sendvercode"
            @validateUsername="validateUsername"
            @validateCode="validateCode"
            @back="back"
          ></forget-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForgetForm from "../../components/form/ForgetForm";
import { getUrlParam, encrypt } from "../../utils/utils";
import { token, postRequest } from "../../utils/api";
import i18n from '../../utils/i18n'
export default {
  data() {
    return {
      isSending: false,
      isValidated: true,
      btntxt:"",
      isNull:true,
      time: 0,
      user: {
        loginid: "",
        langcode: "",
        vercode: "",
      },
      titleLabel: i18n.t("forget_pageText.FINDPASS")
    };
  },
  mounted() {
    this.init();
  },
  components: {
    ForgetForm
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.init();
  },
  computed: {

  },
  methods: {
    changeLang(lang) {
      let _this = this;
      _this.$i18n.locale = lang;
    },
    init() {
      let lang = getUrlParam("langcode");
      if (lang) {
        this.changeLang(lang.toUpperCase());
      } else {
        this.changeLang("EN");
      }
    },
    sendvercodeHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("getVercode", {
          suppliername : user.loginid,
          isforget : true
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    sendvercode(){
      let _this = this; 
      _this.user.langcode = _this.$i18n.locale;
      _this
        .sendvercodeHandle(_this.user)
        .then(res => {
          if (res.success) {
           _this.isSending = true;
           _this.time = 900;
           _this.timer();
          } else {
            _this.isSending = false;
          }
        })
        .catch(error => {
          _this.isSending = false;
        });
    },
    timer(){
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + " " + i18n.t("login_pageText.RESEND");
        setTimeout(this.timer, 1000);
      } else {
          this.time = 0;
          this.isSending = false;
      }
    },
    validateUsernameHandler(user){
      return new Promise((resolve, reject) => {
        postRequest("validate", {
          suppliername : user.loginid,
          type: "1"
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    validateUsername(){
      let _this = this; 
      _this.user.langcode = _this.$i18n.locale;
      _this
        .validateUsernameHandler(_this.user)
        .then(res => {
          if (res.success) {
            _this.isValidated=false;
            //console.log("username is Existing");
          } else {
            _this.isValidated=true;
            _this.$message.error(i18n.t("warning_pageText.NOTEXIST"));
           //return;
          }
        })
        .catch(error => {
          _this.isSending=false;
        });
    },
    validateCodeHandler(user){
      return new Promise((resolve, reject) => {
        postRequest("validate", {
          suppliername : user.loginid,
          type: "2",
          code:user.vercode
        })
          .then(res => {
            let datas = res.data;
            resolve(datas);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    validateCode(){
      let _this = this; 
      _this.user.langcode = _this.$i18n.locale;
      _this
        .validateCodeHandler(_this.user)
        .then(res => {
          if (res.success) {
            let hrid = _this.user.loginid;
            // _this.$store.commit("user/setLanguage", _this.user.langcode);
             _this.$store.commit("user/setHrid", hrid);
             _this.$store.commit("user/setIsForget","1");
            // _this.$store.commit("user/setSiteId", siteid);
            // _this.$store.commit("user/setEmailverified", emailverified);
             //console.log(hrid);
            _this.$router.replace({
              path: "/"
            });
          } else {
            _this.$message.error(i18n.t("warning_pageText.VERCODE_ERROR"));
          }
        })
        .catch(error => {
          _this.isSending=false;
        });
    },
    back(){
      let _this = this;
      _this.$router.go(-1);
    },
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.titleLabel = i18n.t("login_pageText.LOG_IN");
    }
  }
};
</script>
<style scoped>
.login_main_container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 700px; */
  height: 100%;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;
}

.bg_box {
  width: 100%;
  padding: 10px;
  overflow: hidden;
  box-sizing: border-box;
}

.login_title {
  padding: 10px 30px 0 30px;
  text-align: center;
}

.login_title > .logo {
  width: 132px;
  margin-bottom: 20px;
}

.login_title > .line {
  width: 400px;
  height: 2px;
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    #bababa,
    rgba(255, 255, 255, 0)
  );
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    #bababa,
    rgba(255, 255, 255, 0)
  );
  margin: 0 auto;
}

.login_title > .title {
  margin: auto;
  padding: 20px 0 30px 0;
}

.login_box {
  width: 600px;
  /* height: 400px; */
  background-color: #fffc;
  -webkit-box-shadow: 0 0 10px #bababa;
  box-shadow: 0 0 10px #bababa;
  border-radius: 8px;
  border: 1px solid #ddd;
  margin: 0 auto;
  padding: 20px 10px;
  box-sizing: border-box;
}

.login_form {
  margin: 0 auto;
}

.tab_group {
  width: 420px;
  height: 45px;
  margin: 43px auto 0;
}

.tab-button {
  width: 158px;
  height: 45px;
  border: 0;
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;
  color: #666;
}

.tab-button:hover {
}

.tab-button:active {
}

.tab-button:focus {
  outline: 0;
}

.active {
  color: #ffa000;
  border-bottom: 3px solid #ffa000;
  border-radius: 0;
  vertical-align: top;
}

.tab {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
